export const STATUS_CREATED = 'created';
export const STATUS_PAYED = 'payed';
export const STATUS_SAVED = 'saved';
export const STATUS_FORMED = 'formed';
export const STATUS_SENT = 'sent';
export const STATUS_CONFIRMED = 'confirmed';
